const adminFields = `
	id
	email
	is_saas
	is_super
	events {
		id
		name
		client_id
	}
	clients {
		id
		name
	}
	perms {
		id
		permission
		event {
			id
			name
			client_id
		}
	}
`;
// FindAdminByEmail in the backend
export const ADMIN = `
	query admin($email: String) {
		admin(email: $email) {
			${adminFields}
		}
	}
`;

export const ADMINS = `
	query admins {
		admins {
			${adminFields}
		}
	}
`;
